import { supabase } from './supabase';

export async function setupDatabase() {
  console.log('Checking database tables...');

  try {
    // Check if estimation_files table exists
    const { data: filesTable, error: filesCheckError } = await supabase
      .from('estimation_files')
      .select('id')
      .limit(1);

    if (filesCheckError?.code === '42P01' || filesCheckError?.message?.includes('relation') || filesCheckError?.message?.includes('does not exist')) {
      console.warn('estimation_files table does not exist. Run the setup SQL in Supabase.');
    } else if (!filesCheckError) {
      console.log('✓ estimation_files table exists');
    }

    // Check if estimation_specs table exists
    const { data: specsTable, error: specsCheckError } = await supabase
      .from('estimation_specs')
      .select('id')
      .limit(1);

    if (specsCheckError?.code === '42P01' || specsCheckError?.message?.includes('relation') || specsCheckError?.message?.includes('does not exist')) {
      console.warn('estimation_specs table does not exist. Run the setup SQL in Supabase.');
    } else if (!specsCheckError) {
      console.log('✓ estimation_specs table exists');
    }

    // Note: Bucket creation requires service key and should be done via Supabase dashboard
    // The 'bucket' storage bucket should already exist in your Supabase project
    
    console.log('Database setup completed successfully');
    return { success: true };
  } catch (error) {
    console.error('Error setting up database:', error);
    return { success: false, error };
  }
}
